import CountUp from 'react-countup'
import { useStats } from '@/lib/hooks'

export function StatsStrip() {
  const { data } = useStats()
  if (!data) return null
  return (
    <section className="relative overflow-hidden border-y-[3px] border-cosmos-green bg-pitch-900 text-white py-14">
      <div className="absolute inset-0 [background:radial-gradient(circle_at_20%_50%,rgba(28,168,74,0.18),transparent_45%),radial-gradient(circle_at_80%_50%,rgba(245,197,24,0.14),transparent_45%)]" />
      <div className="container-narrow relative">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
          {data.clubStats.map((s, i) => (
            <div key={s.label} className={i < data.clubStats.length - 1 ? 'md:border-r md:border-white/12 md:pr-4' : ''}>
              <div className="text-center">
                <div className="font-display text-6xl md:text-7xl text-cosmos-gold num leading-none">
                  <CountUp end={s.value} duration={2.2} enableScrollSpy scrollSpyOnce />
                </div>
                <div className="mt-3 text-[11px] uppercase tracking-[0.18em] text-white/75">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
